import { createStore, applyMiddleware } from "redux";
import rootReducer from "./reducers";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const config = {
  key: "root",
  storage,
  blacklist: ["knowledgeCube"]
};

const persistedReducer = persistReducer(config, rootReducer);
const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);
// eslint-disable-next-line import/no-anonymous-default-export
export  {
  store,
  persistor
};  
